const NETWORK_URL_KEY = "hene.net.wsUrl";
const DEFAULT_NET_URL = "ws://localhost:8787";
const DEFAULT_PROD_NET_URL = "wss://hene-town-server.onrender.com";
const DEFAULT_LOCAL_NET_PORT = "8787";

function normalizeCandidate(raw) {
  if (typeof raw !== "string") return "";
  const trimmed = raw.trim();
  return trimmed;
}

function getGlobalConfigUrl() {
  return normalizeCandidate(globalThis?.HENE_CONFIG?.wsUrl);
}

function isLocalPage() {
  const hostname = globalThis?.location?.hostname || "";
  return hostname === "localhost" || hostname === "127.0.0.1";
}

function isPrivateHost(hostname) {
  if (!hostname) return false;
  if (hostname === "localhost" || hostname === "127.0.0.1") return true;
  return /^([0-9]{1,3}\.){3}[0-9]{1,3}$/.test(hostname)
    && (
      /^10\./.test(hostname)
      || /^172\.(1[6-9]|2[0-9]|3[0-1])\./.test(hostname)
      || /^192\.168\./.test(hostname)
      || /^169\.254\./.test(hostname)
    );
}

function getInferredLocalNetworkUrl() {
  const hostname = globalThis?.location?.hostname || "";
  if (!isPrivateHost(hostname)) return "";
  if (/^ws:\/\//iu.test(hostname) || /^wss:\/\//iu.test(hostname)) return "";
  return `ws://${hostname}:${DEFAULT_LOCAL_NET_PORT}`;
}

function getStorageUrl() {
  if (!globalThis?.localStorage?.getItem) return "";
  try {
    return normalizeCandidate(globalThis.localStorage.getItem(NETWORK_URL_KEY));
  } catch {
    return "";
  }
}

function sanitizeStorageUrlForHost(rawUrl) {
  const url = normalizeCandidate(rawUrl);
  if (!url) return "";
  if (isLocalPage()) return url;
  // Prevent stale local overrides from forcing production pages to localhost.
  if (/^ws:\/\/(localhost|127\.0\.0\.1)(:\d+)?/iu.test(url)) return "";
  return url;
}

function getViteEnvUrl() {
  try {
    return normalizeCandidate(globalThis?.import?.meta?.env?.VITE_HENE_WS_URL);
  } catch {
    return "";
  }
}

function getRenderBackendUrl() {
  const hostname = globalThis?.location?.hostname || "";
  if (!hostname || !hostname.endsWith(".onrender.com")) return "";
  let base = hostname.replace(/\.onrender\.com$/u, "");
  if (base.endsWith("-client")) {
    base = base.replace(/-client$/u, "");
  }
  if (base.endsWith("-server")) {
    return `wss://${hostname}`;
  }
  return `wss://${base}-server.onrender.com`;
}

export function resolveWebSocketUrl() {
  const fromGlobal = getGlobalConfigUrl();
  if (fromGlobal) return fromGlobal;

  if (isLocalPage()) return DEFAULT_NET_URL;

  const fromVite = getViteEnvUrl();
  if (fromVite) return fromVite;

  const fromInferred = getInferredLocalNetworkUrl();
  if (fromInferred) return fromInferred;

  const fromStorage = sanitizeStorageUrlForHost(getStorageUrl());
  if (fromStorage) return fromStorage;

  const inferredRenderUrl = getRenderBackendUrl();
  if (inferredRenderUrl) return inferredRenderUrl;

  return DEFAULT_PROD_NET_URL;
}

export { NETWORK_URL_KEY, DEFAULT_NET_URL, DEFAULT_PROD_NET_URL };
